import creditCardType from 'credit-card-type';
import ccChecksum from 'vendor/cc-checksum';

/*
 * Required extra fields
 * plan
 * product
 * coupon
 */
$(document).ready(function () {
  // Hacky... the billing_data global is set via the following file:
  // app/assets/javascripts/pages/billing_data.js.erb
  //
  // This was done to avoid having to use ERB with webpack which was buggy.
  // See: https://github.com/usabilityhub/rails-erb-loader/issues/63
  const statesUS = window.billing_data.statesUS;
  const regionsCanada = window.billing_data.regionsCanada;

  const form = $('.js-payment-form');
  const postalCodeElem = $('.js-billing-credit-card-postal-code');
  const countryElem = $('.js-billing-credit-card-country');
  const stateElemContainer = $('.js-billing-credit-card-state-container');
  const stateElem = $('.js-billing-credit-card-state');
  const stateComputedElem = $('.js-billing-credit-card-state-computed');
  const ccNumberElem = $('.js-billing-credit-card-number');
  const ccTypeElem = $('.js-billing-credit-card-type');
  const ccCvvElem = $('.js-billing-credit-card-cvv');

  form.on('change', function () {
    var encryptedValuesField = $('[name=encrypted_values]');
    $(encryptedValuesField).val(buildEncryptedValues());
  });

  form.on('submit', function (e) {
    var selectedPlan = $('input#yearly');
    var selectedProduct = $('input#product');
    var plan = selectedPlan.val() == "true" ? "yearly" : "monthly";
    var product = selectedProduct.val();
    var state = stateElem.val()

    if(state !== null && state !== '') {
      stateComputedElem.val(state);
    } else {
      stateComputedElem.val('na');
    }

    $('[name=field_passthrough1]').val(plan)
    $('[name=field_passthrough2]').val(product)

    return true;
  });

  ccCvvElem.on("keypress change paste", function (e) {
    return allowOnlyNumbers(e);
  });

  countryElem.on('change', function () {
    if ('USA' === $(this).val()) {
      addStatesSelectBox(statesUS, stateElem, stateElemContainer)
    } else if ('CAN' === $(this).val()) {
      addStatesSelectBox(regionsCanada, stateElem, stateElemContainer)
    } else {
      stateElemContainer.addClass('hidden');
      stateElem.prop('required', false);
      stateComputedElem.prop('value', 'na');
      stateElem.children().remove();
    }
  })

  ccNumberElem.on("keypress change", function (e) {
    setCCNumberMaxLength();
    return allowOnlyNumbers(e);
  });

  ccNumberElem.on('keyup change', function (e) {
    if(e.keyCode == 8 || e.keyCode == 46) {
      // do nothing if user is deleting 8 - backspace, 46 - delete
      // prevents wird behavior when user is editing entered number
      return
    }
    $(this).val(function (index, value) {
      return formatCreditCardNumber(value);
    });
  });

  ccNumberElem.on('paste', function () {
    let elem = $(this);
    setCCNumberMaxLength();
    // Trigger same behavior as change, such as formatting after the paste has
    // been done
    setTimeout(function () { elem.trigger("change"); });
  });

  ccCvvElem.on('input', function () {
    // on input we want only to clear validation errors immediately when user
    // typed in correct data but we do not want to show errors right when they
    // start typing e.g. their cvv number
    var card = getCard();

    if(card !== null) {
      var validationResult = {
        code: cvvCodeValidation(ccCvvElem, card),
        valid: function() {
          return this.code === true
        }
      }

      if(validationResult.valid()) {
        ccCvvElem[0].setCustomValidity('');
      }
    }
  });

  ccNumberElem.on('input', function () {
    // on input we want only to clear validation errors immediately when user
    // typed in correct data but we do not want to show errors right when they
    // start typing e.g. their cc number
    var card = getCard();

    if(card !== null) {
      var validationResult = {
        number: ccNumberValidation(ccNumberElem, card),
        type: ccTypeValidation(card),
        valid: function() {
          return this.number === true && this.type === true
        }
      }

      if(validationResult.valid()) {
        ccNumberElem[0].setCustomValidity('');
      }
    }
  });

  ccNumberElem.add(ccCvvElem).on('change', function () {
    var submitButton = $('.js-billing-submit-button');
    var card = getCard();

    if(card !== null) {
      setCCNumberMaxLength();

      var validationResult = {
        number: ccNumberValidation(ccNumberElem, card),
        code: cvvCodeValidation(ccCvvElem, card),
        type: ccTypeValidation(card),
        valid: function() {
          return this.number === true && this.code === true && this.type === true
        }
      }

      if(validationResult.valid()) {
        ccNumberElem[0].setCustomValidity('');
        ccCvvElem[0].setCustomValidity('');
        submitButton.prop('disabled', false);
        ccTypeElem.val(getCreditCardType(card));
      } else {
        setValidationMessages(validationResult);
        ccTypeElem.val('');
        submitButton.prop('disabled', true);
      }
    }
  });

  function formatCreditCardNumber(value) {
    // Remove non-numeric chars
    value = value.trim().split(' ').join('').replace(/\D/g, '');
    // Group per 4 digits
    value = value.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
    return value;
  }

  function getCreditCardType(card) {
    var zuoraType;

    /*
     * Mapping done based on https://knowledgecenter.zuora.com/CB_Billing/LA_Hosted_Payment_Pages/B_Payment_Pages_2.0/P_Implement_Direct_POST_for_Payment_Methods/Direct_POST_Payment_Pages_2.0_Form_Fields#Direct_POST_Fields_for_Credit_Card
     *
     * List of supported CC types by Braintree is taken from here: https://knowledgecenter.zuora.com/CB_Billing/L_Payment_Methods/Supported_Payment_Methods
     *
     * Seems JCB CC are not supported so it is not present on below list.
     */
    switch(card.type) {
      case 'visa':
        zuoraType = 'Visa';
        break;
      case 'mastercard':
        zuoraType = 'MasterCard';
        break;
      case 'american-express':
        zuoraType = 'AmericanExpress';
        break;
      case 'discover':
        zuoraType = 'Discover';
        break;
      case 'diners-club':
        // Note in Braintree link: "Diners Club cards are processed as Discover cards."
        zuoraType = 'Discover';
        break;
    }

    return zuoraType;
  }

  function getCard() {
    var ccNumber = ccNumberElem.val();
    var cards = creditCardType(ccNumber);
    if (cards !== undefined) {
      var card = cards[0];

      if(card !== undefined) {
        return card;
      }
    }

    return null;
  }

  function setValidationMessages(validationResult) {
    if(validationResult.number === false) {
      ccNumberElem[0].setCustomValidity('Credit Card number is invalid.');
      ccNumberElem[0].reportValidity();
    } else if(validationResult.type === false) {
      ccNumberElem[0].setCustomValidity('This type of card is not supported.');
      ccNumberElem[0].reportValidity();
    } else if(validationResult.code === false) {
      ccCvvElem[0].setCustomValidity('CVV/CVC number is invalid.');
      ccCvvElem[0].reportValidity();
    }
  }

  function setCCNumberMaxLength() {
    var ccNumber = ccNumberElem.val();
    var card = getCard();

    if(card !== null) {
      var maxLength = Math.max.apply(Math, card.lengths);
      // input field maxlength is CC type maxlenght + number of spaces
      // between each group of 4 digits
      var rest = maxLength % 4;
      var numberOfSpaces;
      if(rest === 0) {
        numberOfSpaces = Math.floor((maxLength / 4) - 1);
      } else {
        numberOfSpaces = Math.floor(maxLength / 4);
      }

      ccNumberElem.prop('maxlength', maxLength + numberOfSpaces);
    }
  }

  function ccNumberValidation(ccNumberElem, card) {
    var lengths = card.lengths;
    var ccNumber = $(ccNumberElem).val().trim().split(' ').join('');
    var ccNumberLength = ccNumber.length;

    var index = $.inArray(ccNumberLength, card.lengths);

    if(index != -1 && ccChecksum.validate(ccNumber) === true) {
      return true;
    } else {
      return false;
    }
  }

  function cvvCodeValidation(cvvElem, card) {
    var size = card.code.size
    var cvvCodeLength = $(cvvElem).val().trim().length;

    if(cvvCodeLength === size) {
      cvvElem[0].setCustomValidity('');
      return true;
    } else {
      return false;
    }
  }

  function ccTypeValidation(card) {
    var ccType = getCreditCardType(card);

    if(ccType !== undefined) {
      ccNumberElem[0].setCustomValidity('');
      return true;
    } else {
      return false;
    }
  }

  // Only returns true if the keypress associated with the event involves a
  // numeric key
  function allowOnlyNumbers(e) {
    var keyCode = e.which ? e.which : e.keyCode
    if (!(keyCode >= 48 && keyCode <= 57)) {
      return false;
    }
  }

  function addStatesSelectBox(states, stateElem, stateElemContainer) {
    stateElem.children().remove();
    stateElem.append(new Option("", "")); // Add empty element

    states.forEach(function (state) {
      stateElem.append(new Option(state.name, state.code));
    });

    stateElem.prop('required', true);
    stateElemContainer.removeClass('hidden');
  }

  function buildEncryptedValues() {
    // split and join as we group digits in fours for ux when user types in the number
    var creditCardNumber = $('[name=credit_card_number]').val().trim().split(' ').join('');
    var creditCardSecurityCode = $('[name=credit_card_security_code]').val();
    var creditCardExpirationMonth = $('[name=credit_card_expiration_month]').val();
    var creditCardExpirationYear = $('[name=credit_card_expiration_year]').val();

    // 1) Construct credit card data to a string in the desired format
    var unencrypted_values = "#" + creditCardNumber + "#" + creditCardSecurityCode + "#" + creditCardExpirationMonth + "#" + creditCardExpirationYear;

    // 2) Base64 encode the string, 3) Encrypt the Base64 string
    // and 4) Base64 encode the encrypted data
    return encryptText(unencrypted_values, $(".js-zuora-hpm-public-key").val());
  }

  /**
   * encrypt the text using the specified public key.
   * @param text the text to be encrypted.
   * @param key the public key.
   * @returns Base64 encoded encrypted data.
   */
  function encryptText(text, key) {
    if (key) {
      try {
        var key = pidCryptUtil.decodeBase64(key);
        var rsa = new pidCrypt.RSA();
        //ASN1 parsing
        var asn = pidCrypt.ASN1.decode(pidCryptUtil.toByteArray(key));
        var tree = asn.toHexTree();

        //setting the public key for encryption with retrieved ASN.1 tree
        rsa.setPublicKeyFromASN(tree);

        // Base64 encode and encrypt the string
        var crypted = rsa.encrypt(text);

        return pidCryptUtil.encodeBase64(pidCryptUtil.convertFromHex(crypted));
      } catch (e) {
        console.info(e);
      }
    }
    // return origin text if unable to encrypt
    return text;
  }
});
